import React, { useEffect, useState } from 'react';
import { Button, Badge, Spinner, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import DetalhesAtivo from '~/Components/AdmVendas/DetalhesAtivo';
import * as api from '~/Services/Service';
import { DescricoesTiposDocDigital, TiposDocDigital } from '~/constant';
import { downloadFileViaUrl } from '~/Utils/Helpers';
import { verificarPodeVerAssinaturas } from '../helpers';
import {
  FaInfoCircle,
  FaSearch,
  FaWindowClose,
  FaExclamationTriangle,
} from 'react-icons/fa';
import ModalDetalhes from '~/Components/AdmVendas/ModalDetalhes';
import Loading from '~/Components/Loading';

const ResumoPreVendaDocumentoDigital = ({
  documento,
  onVendaEfetivadaChange,
}) => {
  const [isDownloadingFile, setIsDownloadingFile] = useState(false);
  const [ativo, setAtivo] = useState(null);
  const [showDetalhes, setShowDetalhes] = useState(false);
  const [detalhesProposta, setDetalhesProposta] = useState(null);
  const [situacaoEnvolvidos, setSituacaoEnvolvidos] = useState(null);
  const [loadingSituacaoEnvolvidos, setLoadingSituacaoEnvolvidos] = useState(
    false
  );
  const [showAvisoCasa, setShowAvisoCasa] = useState(false);

  const downloadContrato = async () => {
    setIsDownloadingFile(true);
    try {
      const response = await api.getDownloadUrl(documento.codigo);
      downloadFileViaUrl(response);
    } catch (err) {
      toast.error(
        err.message || 'Falha ao buscar o link de download do documento digital'
      );
    } finally {
      setIsDownloadingFile(false);
    }
  };

  const {
    pre_venda: preVenda,
    tipo,
    descricao_status,
    usuario_solicitacao,
  } = documento;
  const podeVerAssinaturas = verificarPodeVerAssinaturas(documento);

  const cpfCliente = preVenda.cliente.cpf;

  const definirSituacaoEnvolvidos = async () => {
    const compradores = documento.signatarios.filter(s => s.is_comprador);

    const compradoresResponse = await Promise.all(
      compradores.map(signatario =>
        api.getPesquisaStatusSituacaoCliente(signatario.cpf)
      )
    );

    let temAdimplente = false;
    for (const comprador of compradoresResponse) {
      if (!comprador) continue;

      if (comprador.situacao_geral === 'Inadimplente') {
        return 'Inadimplente';
      }

      if (comprador.situacao_geral === 'Adimplente') {
        temAdimplente = true;
      }

      if (comprador.agregados && comprador.agregados.length > 0) {
        for (const agregado of comprador.agregados) {
          if (agregado.situacao === 'Inadimplente') {
            return 'Inadimplente';
          }

          if (agregado.situacao === 'Adimplente') {
            temAdimplente = true;
          }
        }
      }
    }

    if (temAdimplente) {
      return 'Adimplente';
    }

    return 'Cliente Novo';
  };

  const getSituacaoClienteColor = situacaoCliente => {
    switch (situacaoCliente) {
      case 'Inadimplente':
        return 'red';
      case 'Adimplente':
        return 'green';
      case 'Cliente Novo':
        return 'blue';
      default:
        return 'black';
    }
  };

  const situacaoClienteColor = getSituacaoClienteColor(situacaoEnvolvidos);

  useEffect(() => {
    const carregarSituacaoEnvolvidos = async () => {
      setLoadingSituacaoEnvolvidos(true);
      try {
        const result = await definirSituacaoEnvolvidos();
        setSituacaoEnvolvidos(result);
      } finally {
        setLoadingSituacaoEnvolvidos(false);
      }
    };

    carregarSituacaoEnvolvidos();
  }, []);

  useEffect(() => {
    const buscarDetalhes = async () => {
      if (!preVenda) return;
      try {
        const [ativoResponse, propostaResponse] = await Promise.all([
          api.detalharPreVenda(preVenda.numero),
          api.consultarAdmVendas({ pre_venda: preVenda.numero }),
        ]);

        if (ativoResponse) {
          setAtivo(ativoResponse);
          if (
            tipo === TiposDocDigital.ContratoVenda &&
            ativoResponse.casa !== 0
          ) {
            setShowAvisoCasa(true);
          }
        }

        if (propostaResponse && propostaResponse.length > 0) {
          setDetalhesProposta(propostaResponse[0]);
          if (onVendaEfetivadaChange) {
            onVendaEfetivadaChange(propostaResponse[0].venda_efetivada === 'S');
          }
        }
      } catch (error) {
        toast.error(error.message);
      }
    };

    buscarDetalhes();
  }, [preVenda]);

  const handleShowDetalhes = () => setShowDetalhes(true);
  const handleCloseDetalhes = () => setShowDetalhes(false);

  const handleFecharAvisoCasa = () => {
    setShowAvisoCasa(false);
    window.close();
  };

  return (
    <section className="my-2">
      <Modal
        show={showAvisoCasa}
        onHide={handleFecharAvisoCasa}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-warning">
            <FaExclamationTriangle className="mr-2" />
            Atenção
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Não é possível gerar contrato de compra e venda para ativo com
            construção.
          </p>
          {ativo && (
            <p className="text-muted">
              Construção: <strong>{ativo.casa}</strong> - Casa
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleFecharAvisoCasa}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="d-flex justify-content-between align-items-center">
        <h5>Pré-venda {preVenda ? preVenda.numero : '-'}</h5>
        <div>
          <Button
            variant="link"
            onClick={handleShowDetalhes}
            title="Ver detalhes da pré-venda"
            className="d-inline-flex align-items-center"
            disabled={!ativo || !detalhesProposta}
          >
            <FaSearch size={20} />
            <span className="ml-2 d-xs-none">Ver detalhes</span>
          </Button>
        </div>
      </div>
      <hr />
      {detalhesProposta ? (
        <ModalDetalhes
          mostrarModal={showDetalhes}
          setMostrarModal={setShowDetalhes}
          linhaSelecionada={detalhesProposta}
        />
      ) : (
        showDetalhes && (
          <Modal
            show={showDetalhes}
            onHide={handleCloseDetalhes}
            centered
            size={'xl'}
            backdrop="static"
          >
            <Modal.Header closeButton>
              <Modal.Title>Carregando detalhes da pré-venda</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="d-flex justify-content-center my-4">
                <Spinner animation="border" />
              </div>
            </Modal.Body>
          </Modal>
        )
      )}
      {tipo === 1 && (
        <>
          <h5 className="d-flex align-items-center">
            Situação envolvidos:{' '}
            {loadingSituacaoEnvolvidos ? (
              <>
                <Spinner
                  animation="border"
                  size="sm"
                  className="ml-2"
                  role="status"
                />
                <span
                  className="ml-2 text-muted"
                  style={{ fontSize: '0.9rem' }}
                >
                  Carregando situação envolvidos...
                </span>
              </>
            ) : situacaoEnvolvidos ? (
              <strong
                style={{ marginLeft: '4px', color: situacaoClienteColor }}
              >
                {situacaoEnvolvidos}
              </strong>
            ) : (
              '-'
            )}
            {!loadingSituacaoEnvolvidos &&
              situacaoEnvolvidos &&
              situacaoEnvolvidos !== 'Cliente Novo' && (
                <small>
                  <a
                    className="ml-2"
                    href={`/cliente/pesquisa/situacao/${cpfCliente}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaInfoCircle />
                    <span className="d-none d-lg-inline">Detalhes</span>
                  </a>
                </small>
              )}
          </h5>
          <hr />
        </>
      )}

      <div className="d-sm-flex justify-content-between">
        <div>
          <span className="d-block">
            Empreendimento: {preVenda ? preVenda.empreendimento.descricao : '-'}
          </span>
          <span className="d-block">
            <span>Quadra: {preVenda ? preVenda.imovel.quadra : '-'}</span>
            <span className="ml-1">
              Lote: {preVenda ? preVenda.imovel.lote : '-'}
            </span>
            <span>{ativo && ativo.casa != 0 && ' (CASA)'}</span>
          </span>
        </div>
        <div className="align-self-start d-flex flex-column align-items-end">
          <Badge variant="dark" className="mb-1">
            {DescricoesTiposDocDigital[tipo]}
          </Badge>
          <Badge variant="secondary">{descricao_status}</Badge>
          <small className="d-block">
            {usuario_solicitacao
              ? `Solicitado por: ${usuario_solicitacao.nome}`
              : 'Nova solicitação'}
          </small>
          {podeVerAssinaturas && (
            <Button
              variant="info"
              onClick={e => downloadContrato()}
              disabled={isDownloadingFile}
            >
              {isDownloadingFile && (
                <Spinner animation="border" className="mr-2" size="sm" />
              )}
              Ver Assinaturas
            </Button>
          )}
        </div>
      </div>
    </section>
  );
};

export default ResumoPreVendaDocumentoDigital;
